import React from 'react';

const TermsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-3xl mx-auto px-4">
        <div className="bg-white border border-gray-200 rounded-lg p-8 shadow-sm space-y-4">
          <h1 className="text-3xl font-bold text-gray-900">Terms</h1>
          <p className="text-sm text-gray-700">
            This service provides general information and document drafting assistance. It does not provide legal
            advice and does not create an attorney-client relationship.
          </p>
          <p className="text-sm text-gray-700">
            You are responsible for reviewing any generated content and for submitting your appeal on your own behalf.
          </p>
          <p className="text-sm text-gray-700">
            We make reasonable efforts to provide accurate outputs but do not guarantee outcomes. Use of this service
            is at your own risk.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
